import { useMutation, useQuery, UseQueryResult } from '@tanstack/react-query'
import { queryClient, UseMutationResult, useResources } from '.'
import {
  Clocking,
  ClockingCreationPayload,
  create,
  fetch,
  fetchOne,
  FetchClockingsParams,
} from '../api/clockings'
import api from '../api'

//Queries
export const useClockingsQuery = (
  filters?: FetchClockingsParams,
  options?: { refetchInterval?: number; enabled?: boolean },
) =>
  useResources('clockings', fetch, filters || {}, options)

export const useClockingQuery = (
  id: string | undefined,
  options?: { enabled?: boolean },
): UseQueryResult<Clocking, unknown> =>
  useQuery({
    queryKey: ['clocking', id],
    queryFn: async () => fetchOne(id!),
    enabled: !!id && (options?.enabled ?? true),
  })

export const clockingKeys = {
  all: ['clockings'] as const,
  mutations: {
    create: ['clockings', 'create'] as const,
  },
} as const

//Mutations
export const useCreateMutation = (): UseMutationResult<Clocking, ClockingCreationPayload> =>
  useMutation(create, {
    mutationKey: clockingKeys.mutations.create,
    onSuccess: () => {
      queryClient.invalidateQueries(['clockings'])
    },
  })

export const useCheckAppVersionQuery = (interval: number) =>
  useQuery({
    queryFn: async () =>
      api<Record<string, never>, Record<string, never>>({
        endpoint: '/version',
        method: 'head',
      }),
    refetchInterval: () => interval,
    refetchIntervalInBackground: true,
  })
